<template>
    <!-- 修改信息的弹窗 -->
    <el-dialog title="修改信息" :close-on-click-modal="false" :visible.sync="showDialog">
      <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="用户名：" prop="userName">
            {{dataForm.userName}}
        </el-form-item>
        <el-form-item label="手机号：" prop="phonenumber">
          {{dataForm.phonenumber}}
        </el-form-item>
        <el-form-item label="真实姓名：" prop="realName">
          <el-input v-model="dataForm.realName"></el-input>
        </el-form-item>
        <el-form-item label="开户银行：" prop="bankName">
          <el-input v-model="dataForm.bankName"></el-input>
        </el-form-item>
        <el-form-item label="银行卡号：" prop="bankCard">
          <el-input v-model="dataForm.bankCard"></el-input>
        </el-form-item>
        <el-form-item label="支付宝：" prop="alipayCode">
          <el-input v-model="dataForm.alipayCode"></el-input>
        </el-form-item>
        <el-form-item label="微信：" prop="wechatCode">
          <el-input v-model="dataForm.wechatCode"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('dataForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('dataForm')">确 定</el-button>
      </div>
    </el-dialog>
</template>
<script>

import {infoUser, updateUser} from '@/api/money'
import cookies from 'js-cookie'
export default {
  data () {
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('手机号不能为空'))
      }
      const tel = parseFloat(value)
      if (!/^1[0-9]{10}$/.test(tel)) {
        callback(new Error('手机号格式错误'))
      }
      callback()
    }
    return {
      showDialog: false,
      dataForm: {
        userName: undefined,
        phonenumber: undefined,
        realName: undefined,
        bankName: undefined,
        bankCard: undefined,
        alipayCode: undefined,
        wechatCode: undefined
      },
      rules: {
        userName: [
          { required: true, message: '用户名不能为空', trigger: 'blur' }
        ],
        phonenumber: [
          { required: true, validator: validateMobile, trigger: 'blur' }
        ],
        realName: [
          { required: true, message: '真实姓名不能为空', trigger: 'blur' }
        ],
        bankName: [
          { required: true, message: '开户银行不能为空', trigger: 'blur' }
        ],
        bankCard: [
          { required: true, message: '银行卡号不能为空', trigger: 'blur' }
        ],
        alipayCode: [
          { required: true, message: '支付宝不能为空', trigger: 'blur' }
        ],
        wechatCode: [
          { required: true, message: '微信不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.showDialog = true
      infoUser(cookies.get('userId')).then(data => {
        if (data && data.code === 0) {
          this.dataForm.userName = data.user.userName
          this.dataForm.phonenumber = data.user.phonenumber
          this.dataForm.realName = data.user.realName
          this.dataForm.bankName = data.user.bankName
          this.dataForm.bankCard = data.user.bankCard
          this.dataForm.alipayCode = data.user.alipayCode
          this.dataForm.wechatCode = data.user.wechatCode
        }
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      }).catch((err) => {
        this.$message.error(err.msg ? err.msg : '服务器异常，查询用户信息失败，请稍后再试')
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
          this.$refs['dataForm'].resetFields()
        })
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        console.log(this.dataForm)
        if (valid) {
          updateUser({...this.dataForm, userId: parseFloat(cookies.get('userId'))}).then((data) => {
            console.log(data)
          }).catch((err) => {
            this.$message.error(err.msg ? err.msg : '服务器异常，修改用户信息失败，请稍后再试')
          })
          this.showDialog = false
        }
      })
    },
    resetForm () {
      this.showDialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layout/user-upDate.vue